import React from 'react';
import { BookOpen, Youtube, GraduationCap, PlayCircle, Star } from 'lucide-react';

const Academy = () => {
  const courses = [
    { title: "Neural Networks: Zero to Hero", author: "Andrej Karpathy", platform: "YouTube", tag: "Foundational" },
    { title: "Generative AI Specialization", author: "Andrew Ng", platform: "Coursera", tag: "Advanced" },
    { title: "Deep Learning for Coders", author: "Fast.ai", platform: "Independent", tag: "Practical" }
  ];

  return (
    <div className="bg-[#020617] min-h-screen text-white p-8">
      <div className="max-w-6xl mx-auto">
        <header className="mb-12 text-center">
          <div className="inline-block px-3 py-1 bg-indigo-500/10 border border-indigo-500/20 rounded-full text-indigo-400 text-xs font-bold uppercase mb-4">Elite Learning Paths</div>
          <h1 className="text-4xl md:text-6xl font-black mb-4">AI Academy</h1>
          <p className="text-slate-400 max-w-xl mx-auto">Master the architecture of the future with curated resources from the world's leading AI researchers.</p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {courses.map((course, i) => (
            <div key={i} className="bg-slate-900/40 border border-slate-800 p-6 rounded-3xl hover:border-indigo-500/50 transition-all group">
              <div className="flex justify-between items-start mb-6">
                <div className="p-3 bg-indigo-500/10 text-indigo-400 rounded-xl group-hover:scale-110 transition-transform"><PlayCircle /></div>
                <span className="text-[10px] font-bold py-1 px-2 bg-slate-800 rounded-md text-slate-300 uppercase tracking-widest">{course.tag}</span>
              </div>
              <h3 className="text-xl font-bold mb-2">{course.title}</h3>
              <p className="text-slate-500 text-sm mb-4">By {course.author}</p>
              <div className="flex items-center gap-2 text-xs font-bold text-indigo-400">
                <Youtube size={14} /> {course.platform}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Academy;